<template>
  <div>
    <SessionExpiryToast
      :visible="showWarningToast"
      :total-warning-time="timeRemainingUntilExpiry"
      @extend-session="handleExtendSession"
      @dismiss="hideWarningToast"
      @timeout="handleToastTimeout"
    /> 
    <SessionExpiredModal :visible="showExpiredModal" />
  </div>
</template>

<script>
import SessionExpiryToast from './SessionExpiryToast.vue';
import SessionExpiredModal from './SessionExpiredModal.vue';
import { extendSession } from './session.js';

export default {
  name: 'SessionManager',
  components: {
    SessionExpiryToast,
    SessionExpiredModal
  },
  data() {
    return {
      showWarningToast: false,
      showExpiredModal: false,
      warningTime: 120 // 2 minutes in seconds
    };
  },
  mounted() {
    // Listen for session warning events
    window.addEventListener('sessionWarning', this.handleSessionWarning);
    // Listen for session expired events
    window.addEventListener('sessionExpired', this.handleSessionExpired);
    // Listen for session extended events
    window.addEventListener('sessionExtended', this.handleSessionExtended);
  },
  beforeDestroy() {
    // Clean up event listeners
    window.removeEventListener('sessionWarning', this.handleSessionWarning);
    window.removeEventListener('sessionExpired', this.handleSessionExpired);
    window.removeEventListener('sessionExtended', this.handleSessionExtended);
  },
  methods: {
    handleSessionWarning(event) { 
      this.timeRemainingUntilExpiry = event.detail.timeRemainingUntilExpiry || event.detail.warningTime;
      this.showWarningToast = true;
    },
    
    handleSessionExpired(event) { 
      this.hideWarningToast();
      this.showExpiredModal = true;
    },
    
    handleSessionExtended(event) { 
      this.hideWarningToast();
    },
    
    handleExtendSession() { 
      extendSession();
    },
    
    hideWarningToast() {
      this.showWarningToast = false;
    },
    
    handleToastTimeout() { 
      this.hideWarningToast();
      // The session should expire shortly after this
    }
  }
};
</script>

<style scoped>
/* No additional styles needed */
</style>
